import {get, set} from 'lodash'

export default {

    setNewsletterData(state, newsletterData) {
        state.newsletterData = {...(state.newsletterData), ...newsletterData}
    },

    discardNewsletterData(state) {
        state.newsletterData = null
    },

    discardSubscriptionData(state) {
        state.subscriptionData = {}
        state.subscriptionFinishedSuccessful = false
    },

    setSubscriptionData(state, subscriptionData) {
        state.subscriptionData = {...(state.subscriptionData), ...subscriptionData}
    },

    setFormSelectChoices(state, formSelectChoices) {
        state.formSelectChoices = {...(state.formSelectChoices), ...formSelectChoices}
    },

    setSubscriberToken(state, subscriberToken) {
        state.subscriberToken = subscriberToken
    },

    setUnsubscribe(state, unsubscribe) {
        state.unsubscribe = unsubscribe
    },

    setSubscriptionProp(state, {prop, value, path = null}) {
        if (path === null) {
            set(state.subscriptionData, prop, value)
        } else {
            set(get(state.subscriptionData, path), prop, value)
        }
    },

    setNewsletterIsLoaded(state, isLoaded) {
        state.newsletterIsLoaded = isLoaded
    },

    setSubscriptionFinishedSuccessful(state, finished) {
        state.subscriptionFinishedSuccessful = finished
    }
}
